import React from 'react';
import { FaFacebookF, FaTiktok } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function About() {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section với Background Image */}
            <div className="relative h-[600px] flex items-center justify-center overflow-hidden">

                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                    style={{
                        backgroundImage: `url('/images/sliders/slide4.jpg')`   // ← Đường dẫn ảnh từ thư mục public
                    }}
                >
                    {/* Overlay tối để chữ dễ đọc */}
                    <div className="absolute inset-0 bg-black/60"></div>
                </div>

                {/* Nội dung text */}
                <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
                    <h1 className="text-5xl md:text-7xl font-bold mb-6 text-white tracking-tight">
                        Về Bông iu
                    </h1>
                    <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto leading-relaxed">
                        Bảo vệ vẻ đẹp từ trong năng lượng. Bông iu chuyên cung cấp các loại trang sức làm từ
                        đá tự nhiên, đá năng lượng dành cho phái nữ
                    </p>
                    <br />
                    <p className='text-xl md:text-2xl text-white/90 max-w-2xl mx-auto leading-relaxed'>stay gem, stay you</p>
                </div>

                {/* Scroll down indicator */}
                {/* <div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/70 animate-bounce">
                    <div className="flex flex-col items-center">
                        <span className="text-sm tracking-widest">KHÁM PHÁ</span>
                        <div className="w-px h-12 bg-white/50 mt-2"></div>
                    </div>
                </div> */}
            </div>

            <div className="max-w-5xl mx-auto px-6 py-16">
                {/* Giới thiệu ngắn */}
                <div className="max-w-3xl mx-auto text-center mb-16">
                    <h2 className="text-3xl font-semibold text-gray-800 mb-6">
                        Câu chuyện của chúng tôi
                    </h2>
                    <p className="text-lg text-gray-600 leading-relaxed">
                        Bông iu sẽ giúp nuôi dưỡng năng lượng phái đẹp từ bên trong. Cung cấp những trang sức đá xu hướng,
                        không những tôn lên vẻ đẹp vốn có mà còn thể hiện cá tính và phong cách sống
                    </p>
                </div>

                {/* Các giá trị cốt lõi */}
                <div className="grid md:grid-cols-3 gap-8 mb-20">
                    <div className="bg-white p-8 rounded-2xl shadow-sm text-center">
                        <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6 text-3xl">
                            ✨
                        </div>
                        <h3 className="text-xl font-semibold mb-3">Chất lượng cao</h3>
                        <p className="text-gray-600">
                            Chuyên cung cấp các vòng, trang sức được làm từ đá tự nhiên cho dành cho phái nữ
                        </p>
                    </div>

                    <div className="bg-white p-8 rounded-2xl shadow-sm text-center">
                        <div className="w-16 h-16 bg-pink-100 text-pink-600 rounded-2xl flex items-center justify-center mx-auto mb-6 text-3xl">
                            🔥
                        </div>
                        <h3 className="text-xl font-semibold mb-3">Theo trend</h3>
                        <p className="text-gray-600">
                            Các mẫu trang sức, vòng đá theo xu hướng mới nhất
                        </p>
                    </div>

                    <div className="bg-white p-8 rounded-2xl shadow-sm text-center">
                        <div className="w-16 h-16 bg-amber-100 text-amber-600 rounded-2xl flex items-center justify-center mx-auto mb-6 text-3xl">
                            ❤️
                        </div>
                        <h3 className="text-xl font-semibold mb-3">Chăm sóc tận tâm</h3>
                        <p className="text-gray-600">
                            Luôn lắng nghe và thấu hiểu khách hàng
                        </p>
                    </div>
                </div>

                {/* Thông tin thêm */}
                <div className="bg-white rounded-3xl p-10 md:p-16 shadow-sm mb-20">
                    <h2 className="text-3xl font-semibold text-center mb-10">Tại sao nên chọn Bông iu?</h2>

                    <div className="grid md:grid-cols-2 gap-10">
                        <div className="space-y-8">
                            <div className="flex gap-5">
                                <div className="text-4xl">📍</div>
                                <div>
                                    <h4 className="font-semibold text-lg">Mẫu mã đẹp và chất lượng </h4>
                                    <p className="text-gray-600 mt-1">Sản phẩm được thiết kế và làm từ đá tự nhiên, đá nhân tạo (nếu có)</p>
                                </div>
                            </div>
                            <div className="flex gap-5">
                                <div className="text-4xl">🚚</div>
                                <div>
                                    <h4 className="font-semibold text-lg">Giao hàng nhanh chóng</h4>
                                    <p className="text-gray-600 mt-1">Giao hàng toàn quốc trong vòng 3-5 ngày (nếu sẵn hàng)</p>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-8">
                            <div className="flex gap-5">
                                <div className="text-4xl">🔄</div>
                                <div>
                                    <h4 className="font-semibold text-lg">Đổi trả dễ dàng</h4>
                                    <p className="text-gray-600 mt-1">Chính sách đổi trả trong 30 ngày nếu bạn không hài lòng.</p>
                                </div>
                            </div>
                            <div className="flex gap-5">
                                <div className="text-4xl">💬</div>
                                <div>
                                    <h4 className="font-semibold text-lg">Hỗ trợ tận tình</h4>
                                    <p className="text-gray-600 mt-1">Đội ngũ tư vấn luôn sẵn sàng hỗ trợ bạn 24/7.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Liên hệ */}
                <div className="bg-white rounded-3xl p-10 md:p-16 shadow-sm">
                    <h2 className="text-3xl font-semibold text-center mb-10">Trang Liên Hệ</h2>

                    <div className="grid md:grid-cols-2 gap-10">
                        <div className="space-y-8">
                            <div className="flex gap-5">
                                <div className="text-4xl"><FaTiktok /></div>
                                <div>
                                    <h4 className="font-semibold text-lg">TikTok</h4>
                                    <Link target="_blank"
                                        to={`https://www.tiktok.com/@mynghebongiu`} className="text-gray-600 mt-1">@mynghebongiu</Link>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-8">
                            <div className="flex gap-5">
                                <div className="text-4xl"><FaFacebookF /></div>
                                <div>
                                    <h4 className="font-semibold text-lg">Facebook</h4>
                                    <Link target="_blank"
                                        to={`https://www.facebook.com/bongiudamynghecaocap`} className="text-gray-600 mt-1">bongiudamynghecaocap</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Call to Action */}
            <div className="bg-gray-900 text-white py-16 text-center">
                <div className="max-w-2xl mx-auto px-6">
                    <h2 className="text-3xl font-semibold mb-4">Sẵn sàng tìm kiếm phong cách của bạn?</h2>
                    <p className="text-gray-400 mb-8">Hàng trăm sản phẩm đang chờ bạn khám phá</p>
                    <a
                        href="/products"
                        className="inline-block bg-white text-gray-900 font-semibold px-10 py-4 rounded-2xl hover:bg-gray-100 transition text-lg"
                    >
                        Xem tất cả sản phẩm
                    </a>
                </div>
            </div>
        </div>
    );
}

export default About;